<template>
  <div class="kt-portlet left order-sync">
    <div class="kt-portlet__body">
      <div class="row">
        <!-- Header -->
        <div class="kt-portlet__head col-12">
          <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">Order Sync<sup>BETA</sup></h3>
          </div>
          <HelpTextTooltip :text="helpText" />
        </div>

        <div class="row pt-5">
          <!-- Text -->
          <article class="col-12 col-lg-4 d-flex flex-column j">
            <p class="text p-2">
              We have partnered with Order My Gear to facilitate the creatin and
              fulfillment of Team Stores.
            </p>

            <p class="text p-2">
              Any showroom can be turned into an OMG Store (see instructions
              here) - and when that store closes, simply upload your Order
              Report CSV an we'll process it for you.
            </p>
          </article>

          <!-- Upload file and Dropdown -->
          <article class="col-lg-4 col-md-10 m-auto justify-content-between">
            <div class="row">
              <!-- Upload Files -->
              <div
                class="col-12 mb-4 form-group"
                :class="{ validated: has_errors }"
              >
                <div
                  class="dropzone dropzone-default"
                  id="kt_dropzone_form"
                  @change="filesSelected()"
                  @click="triggerUpload()"
                >
                  <div class="files-to-upload" v-if="filesToUpload.length">
                    <span v-for="(file, index) in filesToUpload" :key="index">{{
                      index > 0 ? ", " + file.name : file.name
                    }}</span>
                  </div>
                  <div v-else>Click here to upload Order Report File</div>
                  <input
                    accept=".csv"
                    type="file"
                    multiple="multiple"
                    class="hidden"
                    id="upload_order_sync"
                  />
                </div>
                <div
                  class="error invalid-feedback"
                  v-if="errors.files_to_upload"
                >
                  {{ errors.files_to_upload }}
                </div>
              </div>

              <!-- Projects Dropdown -->

              <label for="reps-dropdown" class="col-12"
                >Please select a sales rep
                <div
                  class="form-group sales-reps"
                  :class="{ validated: has_errors }"
                >
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="sales-rep-spn">
                        <i class="la la-user"></i>
                      </span>
                    </div>

                    <!-- Reps Dropdown -->
                    <v-select
                      class="flex-fill"
                      id="reps-dropdown"
                      v-model="selected_rep_id"
                      :options="reps"
                      :reduce="(rep) => rep.id"
                      placeholder="Select a sales rep"
                      label="name"
                    >
                    </v-select>
                    <!-- end:Reps Dropdown -->
                  </div>
                  <div
                    class="error invalid-feedback"
                    v-if="errors.selected_rep_id"
                  >
                    {{ errors.selected_rep_id }}
                  </div>
                </div>
              </label>
            </div>
          </article>

          <!-- Submit Order -->
          <article class="col-lg-4 flex flex-column justify-content-between">
            <div
              class="check-container kt-checkbox-inline form-group"
              :class="{ validated: has_errors }"
            >
              <label class="kt-checkbox" for="terms">
                <input
                  type="checkbox"
                  name="terms"
                  id="terms"
                  v-model="checkboxAccepted"
                />
                I authorize Founder Sport Group to process the attached order
                report and ship the corresponding items to the locations listed
                in this document. I understand i will be billed for the
                corresponding items at my regular pricing with FSG, along with
                any shipping costs.
                <span :class="{ 'is-invalid': errors.checkbox }"></span>
              </label>
              <div class="error invalid-feedback" v-if="errors.checkbox">
                {{ errors.checkbox }}
              </div>
            </div>

            <button
              class="btn btn-primary btn-sm m-auto upload-sync-file p-3"
              @click="upload()"
            >
              Place Order
            </button>
          </article>
        </div>
      </div>

      <div class="row ordersync-dashboard" v-if="!loading">
        <div class="col-lg-12">
          <div class="kt-portlet__head">
            <div
              class="
                kt-portlet__head-label
                flex-column flex-md-row
                m-auto m-md-0
              "
            >
              <h3 class="kt-portlet__head-title mb-2 mb-md-0">
                Uploaded Files
              </h3>
            </div>
          </div>
          <div class="ordersync-nav row align-center">
            <div class="col-sm-3">
              <div class="form-group">
                <div class="kt-input-icon kt-input-icon--left">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search..."
                    id="team-link-search"
                    v-model="filters.search"
                  />
                  <span class="kt-input-icon__icon kt-input-icon__icon--left">
                    <span>
                      <i class="la la-search"></i>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group flex align-center">
                <label class="col-sm-4" for="one">Status</label>
                <select
                  class="form-control col-sm-8"
                  id="one"
                  v-model="filters.status"
                >
                  <option value="All">All</option>
                  <option value="Processing">Processing</option>
                  <option value="Confirmed">Confirmed</option>
                  <option value="Rejected">Rejected</option>
                </select>
              </div>
            </div>
            <div class="col-sm-5">
              <div class="form-group flex align-center">
                <label class="col-sm-4" for="two">Type</label>
                <select
                  class="form-control col-sm-8"
                  id="two"
                  v-model="filters.type"
                >
                  <option value="All">All</option>
                  <option value="Individual Ship">Individual Ship</option>
                  <option value="Bulk Ship">Bulk Ship</option>
                </select>
              </div>
            </div>
          </div>
          <div class="kt-portlet__body kt-portlet__body--fit">
            <div
              class="
                kt_datatable
                kt-datatable
                kt-datatable--default
                kt-datatable--brand
                kt-datatable--loaded
              "
              id="orders_table"
            >
              <table class="kt-datatable__table table-striped">
                <thead class="kt-datatable__head">
                  <tr class="kt-datatable__row">
                    <th class="kt-datatable__cell kt-datatable__cell--sort">
                      <span>OMG Sale Code</span>
                    </th>
                    <th class="kt-datatable__cell kt-datatable__cell--sort">
                      <span>Store Name</span>
                    </th>
                    <th class="kt-datatable__cell kt-datatable__cell--sort">
                      <span>Project</span>
                    </th>
                    <th class="kt-datatable__cell kt-datatable__cell--sort">
                      <span>Submitted</span>
                    </th>
                    <th class="kt-datatable__cell kt-datatable__cell--sort">
                      <span>Status</span>
                    </th>
                  </tr>
                </thead>
                <tbody class="kt-datatable__body">
                  <OrderSyncRow
                    v-for="order in orders"
                    :key="order.id"
                    :order="order"
                    :filters="filters"
                  />
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row flex flex-center m-5" v-else>
        <span class="kt-spinner kt-spinner--md kt-spinner--info m-5"></span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import OrderSyncRow from "@/components/Dashboard/OrderSync/OrderSyncRow.vue";
import HelpTextTooltip from "@/components/Utils/HelpTextTooltip.vue";
import { mapState } from "vuex";

export default {
  name: "OrderSync",
  components: {
    OrderSyncRow,
    HelpTextTooltip,
  },

  data() {
    return {
      syncLoading: false,
      loading: false,
      omgAccountNumber: "",
      filesToUpload: [],
      checkboxAccepted: false,
      orders: [],
      filters: {
        search: "",
        type: "All",
        status: "All",
      },
      errors: [],
      selected_rep_id: 0,
      helpText:
        "OrderSYNC is a BETA feature - streamlining the process of turning any Gameplan projects into an order. Questions, comments or recommendations? We want to hear from you, please email us at gameplan@foundersportgroup.com",
    };
  },

  computed: {
    ...mapState(["auth"]),
    reps() {
      return this.$store.state.dealer.reps;
    },
    has_errors() {
      return Object.keys(this.errors).length > 0;
    },
  },

  methods: {
    triggerUpload() {
      document.getElementById("upload_order_sync").click();
    },
    filesSelected() {
      this.filesToUpload = document.getElementById("upload_order_sync").files;
    },
    checkForm: function (withToast = true) {
      this.errors = {};
      if (Number(this.selected_rep_id) === 0) {
        this.errors.selected_rep_id = "Sales Rep is required";
      }

      if (!this.filesToUpload.length) {
        this.errors.files_to_upload = "Order Report is required";
      }

      if (!this.checkboxAccepted) {
        this.errors.checkbox = "You have to authorize this process";
      }

      if (!Object.keys(this.errors).length) {
        return true;
      }

      if (withToast) {
        this.$store.dispatch("showToast", {
          txt: "Please verify your information is correct",
          type: "error",
        });
      }
      return false;
    },
    upload() {
      if (this.checkForm()) {
        this.syncLoading = true;
        let formData = new FormData();
        //formData.append("files", this.filesToUpload);
        formData.append("file", this.filesToUpload[0]);
        formData.append("sales_rep", this.selected_rep_id);
        axios
          .post(
            this.$store.state.settings.endpoint + "api/v2/omg-order-sync",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + this.auth.apiToken,
              },
            }
          )
          .then((response) => {
            this.syncLoading = false;
            this.filesToUpload = [];
            this.$store.dispatch("showToast", {
              txt:
                'Succesfully uploaded. Click <a href="' +
                response.data +
                '" target="_blank">here to view the file.</a>',
            });
            axios
              .get(
                this.$store.state.settings.endpoint + "api/v2/omg-order-sync",
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + this.auth.apiToken,
                  },
                }
              )
              .then((response) => {
                this.orders = response.data;
                this.loading = false;
              })
              .catch((error) => {
                this.$store.dispatch("showToast", {
                  txt: error,
                  type: "error",
                });
                this.loading = false;
              });
          })
          .catch((error) => {
            if (error.response.status === 403) {
              this.$store.dispatch("showToast", {
                txt: "The file has already been uploaded before",
                type: "error",
              });
            } else {
              this.$store.dispatch("showToast", {
                txt: error,
                type: "error",
              });
            }
            this.syncLoading = false;
          });
      }
    },
  },

  mounted() {
    this.$store.commit("setActivePage", "order_sync");

    window.scrollTo({
      top: document.getElementById("kt_header").offsetTop,
      behavior: "smooth",
    });

    this.omgAccountNumber = this.$store.state.dealer.omg_account_number;
    this.loading = true;
    //get all sync orders
    axios
      .get(this.$store.state.settings.endpoint + "api/v2/omg-order-sync", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.auth.apiToken,
        },
      })
      .then((response) => {
        this.orders = response.data;
        this.loading = false;
      })
      .catch((error) => {
        this.$store.dispatch("showToast", {
          txt: error,
          type: "error",
        });
        this.loading = false;
      });
  },
};
</script>

<style lang="scss" scoped>
.order-sync {
  #orders_table {
    @media screen and (max-width: 470px) {
      overflow-x: scroll;
    }

    table {
      @media screen and (max-width: 470px) {
        width: 150%;
        border: 4px solid #f3f3f3;
      }
    }
    th,
    td {
      width: 20% !important;
      word-break: break-all;
    }
    th {
      span {
        font-weight: 700;
      }
    }
  }

  #kt_dropzone_form {
    .dropzone {
      height: 4rem !important;
    }
  }
  .upload-sync-order-container {
    margin-top: 15px;
    .upload-sync-file {
      cursor: pointer !important;
      &.disabled {
        cursor: not-allowed !important;
      }
    }
  }
  .sales-reps {
    padding: 0.6rem 0;
  }

  .kt-checkbox > input:not(:checked) {
    span {
      /* border: 1px solid #a4adbd; */
      background: #e4e8ee;
    }
  }
  .company-name {
    margin-top: 20px;
    input {
      margin-bottom: 10px;
    }
    .alert {
      padding: 0;
      .alert-icon {
        padding-right: 10px;
      }
      .alert-text {
        text-align: center;
        @media screen and (max-width: 768px) {
          text-align: left;
        }
        p {
          margin-bottom: 0;
        }
      }
    }
  }
  .video-container {
    @media screen and (max-width: 1024px) {
      margin-top: 20px;
    }
    iframe {
      width: 100%;
      max-width: 530px;
    }
  }

  .ordersync-dashboard {
    margin-top: 30px;
    .kt-portlet__head-title {
      span {
        font-size: 1.1rem;
      }
    }
    .ordersync-nav {
      margin-top: 30px;
    }
  }
}
</style>